import React from 'react'
import { DateFormats } from '../../enums/date-formats';
import { DateFormatter } from '../../utils/date-formatter';

type ComponentProps = {
  title: string;
  value: string;
  updatedAt: Date;
  topElement?: React.ReactNode;
  form: React.ReactNode;
  bottomElement?: React.ReactNode;
  className?: string
};

const SettingsItem: React.FC<ComponentProps> = ({
  title,
  value,
  updatedAt,
  topElement,
  form,
  bottomElement,
  className = ''
}) => {
  const formattedDate = DateFormatter({
    date: updatedAt,
    format: DateFormats['dd-MMM yyyy HH:mm:ss a'],
  });

  return (
    <div className={`flex w-full flex-col max-md:gap-y-4 md:flex-row justify-between ${className}`}>
      <div className="flex w-full border-l-4 border-meta-9 pl-4 py-2">
        {topElement}
        <div className="flex flex-col">
          <span className="text-lg font-medium">
            {`${title}: ${value}`}
          </span>
          <span className="text-md text-gray-500">
            Updated At: {formattedDate}
          </span>
        </div>
        {bottomElement}
      </div>
      <div className='flex w-full'>
        {form}
      </div>
    </div>
  );
};

export default SettingsItem;
